import { render } from "./containerWeighingFields.vue?vue&type=template&id=5a87e1d3&scoped=true"
import script from "./containerWeighingFields.vue?vue&type=script&lang=js"
export * from "./containerWeighingFields.vue?vue&type=script&lang=js"

import "./containerWeighingFields.vue?vue&type=style&index=0&id=5a87e1d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a87e1d3"]])

export default __exports__